import moment from 'moment';

import application from 'application/application';

application.value('API', {
	/*
			Para testar direto na homologação, altere o trecho de código abaixo nas correspondentes posições:
			-- hostname: 'homologacao-api.advise.com.br',  (para homolog)
			-- hostname: '#_{api-hostname}_#', (deixe como estava antes de realizar o push)

			Se for testar com api rodando no localhost:
			-- protocol: 'http:',
			-- hostname: 'localhost:XXXX'
			-- root: 'api/:version',
		*/
	default: {
		protocol: 'https:',
		hostname: '#_{api-hostname}_#',
		// hostname: 'homologacao-api.advise.com.br',
		root: 'core/:version',
		version: 'v1'
	},
	partner: {
		paths: {
			GET: 'parceiros'
		}
	},
	refreshToken: {
		root: 'login/:version',
		paths: {
			POST: 'refresh-token'
		}
	},
	login: {
		root: 'login/:version',
		paths: {
			POST: 'token'
		}
	},
	logout: {
		root: 'login/:version',
		paths: {
			POST: 'log-out'
		}
	},
	forgotPassword: {
		root: 'login/:version',
		paths: {
			POST: 'redefinir-senha',
			PUT: 'alterar-senha'
		}
	},
	groupUsers: {
		paths: {
			GET: 'grupo-usuarios'
		}
	},
	employeeProfilesApplications: {
		paths: {
			GET: 'perfis-aplicacao',
			POST: 'perfis-aplicacao',
			PUT: 'perfis-aplicacao',
			DELETE: 'perfis-aplicacao/:IDs'
		}
	},
	employeeProfiles: {
		paths: {
			GET: 'perfis-colaborador',
			POST: 'perfis-colaborador',
			PUT: 'perfis-colaborador',
			DELETE: 'perfis-colaborador/:IDs',
			disable: 'perfis-colaborador/inativar',
			enable: 'perfis-colaborador/ativar'
		}
	},
	contracts: {
		paths: {
			GET: 'contratos'
		}
	},
	permissions: {
		paths: {
			GET: 'permissoes-usuario-cliente'
		}
	},
	userClientFunctionalities: {
		paths: {
			GET: 'usuario-cliente-funcionalidade/consultar-credito'
		}
	},
	processes: {
		paths: {
			font: 'processos-clientes/fontes-processos',
			additionalInfo: 'processos-clientes/informacoes-adicionais',
			setAsRead: 'processos-clientes/marcar-lidos'
		}
	},
	processesFonts: {
		paths: {
			GET: 'parametros-orgao-judiciario'
		}
	},
	publications: {
		paths: {
			GET: 'publicacoes-clientes',
			pagination: 'publicacoes-clientes/partner',
			setAsRead: 'publicacoes-clientes/marcar-lidos',
			setAsUnread: 'publicacoes-clientes/desmarcar-lidos',
			favorite: 'publicacoes/favoritar',
			unfavorite: 'publicacoes/desfavoritar',
			download: 'publicacoes/download',
			archive: 'publicacoes/arquivar',
			forward: 'publicacoes/encaminhar',
			restore: 'publicacoes/restaurar'
		}
	},
	briefcase: {
		paths: {
			GET: 'pastas-usuarios-clientes',
			POST: 'pastas-usuarios-clientes',
			PUT: 'pastas-usuarios-clientes',
			DELETE: 'pastas-usuarios-clientes/desvincular-movimento',
			forward: 'pastas-usuarios-clientes/encaminhar',
			set: 'pastas-usuarios-clientes/vincular-movimento'
		}
	},
	keyWordsVariations: {
		paths: {
			GET: 'usuario-cliente-palavras-chaves',
			POST: 'usuario-cliente-palavras-chaves',
			DELETE: 'usuario-cliente-palavras-chaves/:IDs',
			enable: 'usuario-cliente-palavras-chaves/ativar',
			disable: 'usuario-cliente-palavras-chaves/inativar',
			diaries: 'usuario-cliente-palavras-chaves/diarios-usuarios'
		}
	},
	userKeywords: {
		paths: {
			GET: 'usuario-palavras-chave'
		}
	},
	userVariations: {
		paths: {
			GET: 'usuario-variacoes'
		}
	},
	userDiaries: {
		paths: {
			GET: 'usuario-diarios'
		}
	},
	diaries: {
		paths: {
			GET: 'diarios'
		}
	},
	clientUserDiaries: {
		paths: {
			GET: 'diarios-usuarios-clientes'
		}
	},
	diariesKeyWords: {
		paths: {
			GET: 'diarios/usuario-grupo'
		}
	},
	movements: {
		paths: {
			GET: 'movimentos-pastas-usuarios-clientes',
			POST: 'movimentos-pastas-usuarios-clientes',
			PUT: 'movimentos-pastas-usuarios-clientes',
			DELETE: 'movimentos-pastas-usuarios-clientes/:IDs',
			forward: 'movimentos-pastas-usuarios-clientes/encaminhar'
		},
		hooks: {
			request(request) {
				if (
					/^(?:POST|PUT)$/.test(request.method) &&
					request.data &&
					request.data.itens
				) {
					request.data.itens.forEach(item => {
						if (item.dataDia && item.dataHora)
							item.dataHoraAndamento = moment(
								`${item.dataDia}T${item.dataHora}`,
								'DD/MM/YYYYTHH:mm'
							).format();
					});
				}

				return request;
			},
			response(response) {
				((response.data && response.data.itens) || []).forEach(item => {
					if (item.dataHoraAndamento) {
						item.dataDia = moment(item.dataHoraAndamento).format('DD/MM/YYYY');

						item.dataHora = moment(item.dataHoraAndamento).format('HH:mm');
					}
				});

				return response;
			}
		}
	},
	noteDiaries: {
		paths: {
			GET: 'cadernos-diarios'
		}
	},
	customers: {
		paths: {
			GET: 'clientes'
		}
	},
	departments: {
		paths: {
			GET: 'departamentos',
			POST: 'departamentos',
			PUT: 'departamentos',
			disable: 'departamentos/inativar',
			enable: 'departamentos/ativar'
		}
	},
	usersCustomers: {
		paths: {
			GET: 'usuarios-clientes',
			PUT: 'usuarios-clientes',
			ChangePassword: 'usuarios/usuario-logado-alterar-senha',
			ChangeEmail: 'usuarios/usuario-logado-alterar-email'
		},
		hooks: {
			request(request) {
				if (
					/^(?:POST|PUT)$/.test(request.method) &&
					request.data &&
					request.data.itens
				) {
					request.data.itens.forEach(item => {
						if (item.pessoa && item.pessoa.dataNascimentoAbertura)
							item.pessoa.dataNascimentoAbertura = moment(
								item.pessoa.dataNascimentoAbertura,
								'DD/MM/YYYY'
							).format();

						if (item.pessoa && item.pessoa.cep)
							item.pessoa.cep = item.pessoa.cep.replace(
								/^(\d{5})\-?(\d{3})$/,
								'$1$2'
							);
					});
				}

				return request;
			},
			response(response) {
				((response.data && response.data.itens) || []).forEach(item => {
					if (item.pessoa && item.pessoa.dataNascimentoAbertura)
						item.pessoa.dataNascimentoAbertura = moment(
							item.pessoa.dataNascimentoAbertura
						).format('DD/MM/YYYY');

					if (item.pessoa && item.pessoa.cep)
						item.pessoa.cep = item.pessoa.cep.replace(
							/^(\d{5})\-?(\d{3})$/,
							'$1-$2'
						);
				});

				return response;
			}
		}
	},
	genders: {
		paths: {
			GET: 'sexo'
		}
	},
	judicialBranches: {
		paths: {
			GET: 'orgao-judiciario'
		}
	},
	federativeUnits: {
		paths: {
			GET: 'uf'
		}
	},
	cities: {
		paths: {
			GET: 'municipios'
		}
	},
	keyWordsClient: {
		paths: {
			POST: 'palavra-chave-cliente/inserir',
			GET: 'palavra-chave-cliente/consultar',
			PUT: 'palavra-chave-cliente/atualizar',
			alterarSituacao: 'palavra-chave-cliente/alterar-situacao',
			alterarSituacaoVariacao: 'palavra-chave-cliente/alterar-situacao-variacao'
		}
	},
	searchPublicationUserClient: {
		paths: {
			GET: 'pesquisa-publicacao/consultar',
			POST: 'pesquisa-publicacao/inserir-atualizar'
		}
	},
	downloads: {
		paths: {
			ongoing: 'andamentos-download',
			movements: 'movimentos-download',
			publications: 'publicacoes-download',
			releases: 'parcelas-download',
			contacts: 'contatos-download',
			all: 'movimentos-download/todos'
		}
	},
	email: {
		paths: {
			ongoing: 'envio-email-andamentos',
			movements: 'envio-email-movimentos',
			publications: 'envio-email-publicacoes',
			prazos: 'envio-email-prazos',
			contato: 'envio-email-contatos',
			parcelas: 'envio-email-parcelas'
		}
	},
	typesOAB: {
		paths: {
			GET: 'tipos-oab'
		}
	},
	searchProcClientUser: {
		paths: {
			GET: 'situacoes-pesquisa-usuario-cliente'
		}
	},
	processClients: {
		paths: {
			POST: 'processos-clientes'
		}
	},
	processHeaders: {
		paths: {
			GET: 'cabecalhos-processos'
		}
	},
	itemsPerPageQuantity: {
		paths: {
			GET: 'qtd-itens-pagina',
			PUT: 'qtd-itens-pagina',
			POST: 'qtd-itens-pagina'
		}
	},
	notificationsEmails: {
		paths: {
			GET: 'emails-usuario-cliente',
			POST: 'emails-usuario-cliente',
			disable: 'emails-usuario-cliente/inativar'
		}
	},
	disableFolder: {
		paths: {
			PUT: 'pastas-usuarios-clientes/inativar'
		}
	},
	userCustomerAutomaticSearch: {
		paths: {
			PUT: 'busca-automatica-processo-usuario-cliente'
		}
	},
	parametersUsers: {
		paths: {
			GET: 'parametros-usuario',
			PUT: 'parametros-usuario',
			POST: 'parametros-usuario'
		}
	},
	subpoena: {
		paths: {
			consultaAcessos: 'intimacao/ConsultaCadastroAcessos',
			consultaIntimacao: 'intimacao/ConsultaListaIntimacoes',
			consultaDetalhe: 'intimacao/ConsultaDetalhe',
			consultaFonte: 'intimacao/ConsultaFonteIntimacoes',
			POST: 'intimacao',
			ativar: 'intimacao/ativar-pesquisa',
			inativar: 'intimacao/inativar-pesquisa',
			excluirPesquisa: 'intimacao/excluir-pesquisa',
			consultaOrgao: 'intimacao/consulta-orgao-judiciario',
			cadastrarCertificado: 'certificados-digitais/a1/cadastrar'
		}
	}
});
